<template lang="html">
    <div >
      <facility-sidebar :facility="facility" @success="$emit('reload')"/>
      <vs-table :data="data">
        <template slot="header">
          <vs-row class="mb-3">
            <vs-col vs-w="3">
              <vs-button
                color="success"
                class="mx-2"
                icon-pack="feather"
                icon="icon-plus"
                @click="add"
              >
                {{ $t('new') }}
              </vs-button>
            </vs-col>
          </vs-row>
        </template>
        <template slot="thead">
          <!-- <th class="qb-sticky" :style="{background:'white'}"></th> -->
          <vs-th>
            {{ $t('name') | capitalize }}
          </vs-th>

          <vs-th>
            {{ $t('address') + ' 1' | capitalize }}
          </vs-th>

          <vs-th>
            {{ $t('address') + ' 2' | capitalize }}
          </vs-th>

          <vs-th>
            {{ $t('city') | capitalize }}
          </vs-th>

          <vs-th>
            {{ $t('zip') | upperCase }}
          </vs-th>
          <vs-th>
            {{ $t('notes') | capitalize }}
          </vs-th>
          <vs-th>
            {{ $t('zone') | upperCase }}
          </vs-th>

          <th class="qb-sticky">
            {{ $t('actions') }}
          </th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="i" v-for="(tr, i) in data">
            <vs-td class="text-left">{{ data[i].Name }}</vs-td>
            <vs-td class="text-left">{{ data[i].Address1 }}</vs-td>
            <vs-td class="text-left">{{ data[i].Address2 }}</vs-td>
            <vs-td class="text-left">{{ data[i].AddressCity }}</vs-td>
            <vs-td class="text-left">{{ data[i].AddressZip }}</vs-td>
            <vs-td class="text-left">{{ data[i].notes }}</vs-td>
            <vs-td class="text-left">{{ data[i].zone_name }}</vs-td>
            <vs-td>
              <div>
              <action-icon icon="EditIcon" :tooltip="$t('edit')" @click="edit(data[i])"/>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
</template>

<script>
import FacilitySidebar from './FacilitySidebar'
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
import mixins from '@/mixins'

export default {
  components: {
    FacilitySidebar,
    ActionIcon,
  },

  data: () => ({
    facility: {
      clientId:'',
      id: '',
      name: '',
      address1: '',
      address2: '',
      addressZip: '',
      addressCity: '',
      zone: null,
      notes:''
    }
  }),

  methods: {
    add() {
      this.facility = {
        clientId:this.id,
        id:'',
        name:'',
        address1:'',
        address2:'',
        addressCity:'',
        addressZip:'',
        zone:null,
      }
      this.$store.dispatch('toggleSidebar', 'facility')
    },

    edit(data) {
      this.facility.clientId = this.id
      this.facility.id = data.FacilitiesId
      this.facility.name = data.Name
      this.facility.address1 = data.Address1
      this.facility.address2 = data.Address2
      this.facility.addressZip = data.AddressZip
      this.facility.addressCity = data.AddressCity
      this.facility.latitude = data.latitude
      this.facility.longitude = data.longitude
      this.facility.zone = data.ZoneId
      this.facility.notes = data.notes
      this.$store.dispatch('toggleSidebar', 'facility')
    }
  },

  props: {
    data: {
      default: () => []
    },

    id:{
      required:true
    }
  }
}
</script>

<style lang="css" scoped>
</style>
